import CONFIGURABLE_CONSTANTS from 'constants/configurable.constants';
import { ROOT_ID } from 'constants/globalConfig.constants';
import type { ShipmentParams } from 'interfaces/Params.interface';
import { SearchField } from 'interfaces/WidgetConfigs.interface';
import { getParameterByName } from 'utils/queryString.utils';

const getPTPRootElement = () => {
  const rootElement = document.getElementById(ROOT_ID);

  /**
   * While client loads the widget, they redirect to other pages too fast,
   * then the widget is unmounting and the root element is removed from the DOM,
   * we need to return null to avoid crash app.
   */
  if (!rootElement) {
    console.warn('No root element found');
    return null;
  }

  return rootElement;
};

export const getAttributeFromElement = (key: string): string => {
  if (!document) return '';

  const element = getPTPRootElement();
  return element?.getAttribute(key);
};

export const getParamsFromUrl = (
  searchFields: SearchField[],
): ShipmentParams[] => {
  return searchFields.reduce((params, { urlParam }) => {
    const value = getParameterByName(urlParam);

    if (value) {
      return [...params, { type: 'urlParam', key: urlParam, value }];
    }

    return params;
  }, []);
};

export const getParamsFromTag = (
  searchFields: SearchField[],
): ShipmentParams[] => {
  return searchFields.reduce((params, { tagParam }) => {
    const value = getAttributeFromElement(tagParam);
    if (value) {
      return [...params, { type: 'tagParam', key: tagParam, value }];
    }

    return params;
  }, []);
};

const mapDomainCustomFontFiles = (customFontFiles) => {
  if (!customFontFiles) return undefined;

  const domain = CONFIGURABLE_CONSTANTS.widgetAssets;

  if (!domain) return customFontFiles;

  return Object.keys(customFontFiles).reduce((result, key) => {
    return {
      ...result,
      [key]: customFontFiles[key].map((item) => {
        const { pathname } = new URL(item);
        return domain + pathname;
      }),
    };
  }, {});
};

export const mapPTPConfig = (data) => {
  const { fonts } = data.attrs;

  // NOTE: mock search field for return.id
  // eslint-disable-next-line no-param-reassign
  data.attrs.return.searchFields = [
    ...data.attrs.return.searchFields,
    {
      key: 'return.id',
      name: 'Return PK',
      urlParam: 'pp_return_pk',
      tagParam: 'pp-return-pk',
    },
  ];

  return {
    id: data.id,
    suggestedCarrier: data.suggested_carrier,
    organizationId: data.organization_id,
    organizationSlug: data.organization_slug,
    organizationName: data.organization_name,
    cmsSlug: data.slug,
    cmsReference: data.reference,
    config: {
      ...data.attrs,
      fonts: {
        ...fonts,
        customFontFiles: mapDomainCustomFontFiles(fonts.customFontFiles),
      },
      language: data.lang,
    },
  };
};
